import { useEffect } from "react";

export const useStoreAwinId = (): void => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const awc = urlParams.get("awc");
    if (awc) {
      sessionStorage.setItem("awc", awc);
    }
  }, []);
};
